import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=f19dca92&scoped=true&"
import script from "./Conversation.vue?vue&type=script&lang=ts&"
export * from "./Conversation.vue?vue&type=script&lang=ts&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=f19dca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19dca92",
  null
  
)

export default component.exports